export const TITLE = {
  type: 'text',
  field: 'title',
  label: 'Título',
  value: '',
};

export const USER = {
  field: 'userId',
  label: 'Editor',
  type: 'asyncAutocomplete',
  requestUrl:
    '/admin/users?performance=true&limit=10&name=#name&sortBy=name&offset=#offset',
  responseKey: 'userList',
};

export const UNIT = {
  field: 'unitId',
  label: 'Unidade',
  type: 'asyncAutocomplete',
  requestUrl:
    '/admin/units?performance=true&limit=10&name=#name&sortBy=name&offset=#offset',
  responseKey: 'unitList',
};

export const CHANNEL = {
  field: 'channelId',
  label: 'Canal',
  type: 'asyncAutocomplete',
  requestUrl:
    '/admin/channels?performance=true&limit=10&name=#name&sortBy=name&offset=#offset',
  responseKey: 'channelList',
};

export const PERSONALITY = {
  field: 'personalityId',
  label: 'Personalidade',
  type: 'asyncAutocomplete',
  requestUrl:
    '/admin/personalities?performance=true&limit=10&name=#name&sortBy=name&offset=#offset',
  responseKey: 'personalityList',
};

export const STATUS = {
  field: 'status',
  label: 'Status',
  type: 'option',
  options: [
    {
      label: 'Publicado',
      value: 'PUBLISHED',
    },
    {
      label: 'Rascunho',
      value: 'DRAFT',
    },
    {
      label: 'Arquivado',
      value: 'ARCHIVED',
    },
    {
      label: 'Transcodificando',
      value: 'TRANSCODING',
    },
    {
      label: 'Erro na transcodificação',
      value: 'FAILED',
    },
    {
      label: 'Expirado',
      value: 'EXPIRED',
    },
    {
      label: 'Agendado',
      value: 'SCHEDULED',
    },
  ],
};

export const VISIBILITY = {
  field: 'visibility',
  label: 'Visibilidade',
  type: 'option',
  options: [
    {
      label: 'Todos',
      value: 'EVERYONE',
    },
    {
      label: 'Usuários autenticados',
      value: 'AUTHENTICATED_USERS',
    },
    {
      label: 'Usuários internos(ADM)',
      value: 'INTERNAL_USERS',
    },
  ],
};

export const COLLECTION = {
  type: 'text',
  field: 'collectionTitle',
  label: 'Coleção',
  value: '',
};

export const KEYWORD = {
  type: 'custom-keyword',
  field: {
    keywordKey: {
      label: 'Chave',
      field: 'keywordKey',
      requestUrl:
        '/admin/keywords?performance=true&limit=10&key=#name&sortBy=name&offset=#offset',
      responseKey: 'keywordList',
    },
    keywordValue: {
      label: 'Palavra-Chave',
      field: 'keywordValue',
    },
  },
};

export const ROLE = {
  field: 'role',
  label: 'Perfil',
  type: 'option',
  options: [
    { label: 'Editor', value: 'EDITOR' },
    { label: 'Gestor', value: 'MANAGER' },
    { label: 'Administrador', value: 'ADMIN' },
  ],
};

export const NAME_OR_EMAIL = {
  type: 'conditional-text',
  field: 'nameOrEmail',
  conditions: {
    email: value => (value.includes('@') ? 'email' : null),
    name: () => 'name',
  },
  label: 'Nome ou Email',
  value: '',
};

export const USER_STATUS = {
  field: 'status',
  label: 'Status',
  type: 'option',
  options: [
    {
      label: 'Ativo',
      value: 'ACTIVE',
    },
    {
      label: 'Inativo',
      value: 'INACTIVE',
    },
    {
      label: 'Pendente',
      value: 'PENDING',
    },
  ],
};
